import {
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  Archive,
  ArrowDown,
  ArrowUp,
  ArrowUpDown,
  AtSign,
  Battery,
  Bell,
  Briefcase,
  Calendar,
  ChartBar,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleAlert,
  CircleCheck,
  CircleDot,
  CircleHelp,
  CirclePause,
  CircleX,
  ClipboardList,
  Clock,
  Contact,
  Copy,
  CreditCard,
  Download,
  Ellipsis,
  ExternalLink,
  Eye,
  FileText,
  Filter,
  Flag,
  Folder,
  Frown,
  HandCoins,
  History,
  House,
  IdCard,
  Inbox,
  Info,
  Key,
  Landmark,
  LogIn,
  Layers,
  LayoutGrid,
  List,
  LoaderCircle,
  Lock,
  LockOpen,
  LogOut,
  Mail,
  MapPin,
  Megaphone,
  MessageSquare,
  Monitor,
  MousePointerClick,
  Package,
  PackageX,
  Pencil,
  Phone,
  PiggyBank,
  Radio,
  Receipt,
  RefreshCw,
  RotateCcw,
  Save,
  Search,
  SearchX,
  Settings,
  Shield,
  ShieldCheck,
  ShieldX,
  Signal,
  Skull,
  Smartphone,
  SquarePen,
  Store,
  Tags,
  ToggleLeft,
  Trash2,
  TriangleAlert,
  TrendingUp,
  Truck,
  User,
  UserX,
  Users,
  Wrench,
  X,
  Zap,
} from 'lucide-angular';

export const APP_ICONS = {
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  Archive,
  ArrowDown,
  ArrowUp,
  ArrowUpDown,
  AtSign,
  Battery,
  Bell,
  Briefcase,
  Calendar,
  ChartBar,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleAlert,
  CircleCheck,
  CircleDot,
  CircleHelp,
  CirclePause,
  CircleX,
  ClipboardList,
  Clock,
  Contact,
  Copy,
  CreditCard,
  Download,
  Ellipsis,
  ExternalLink,
  Eye,
  FileText,
  Filter,
  Flag,
  Folder,
  Frown,
  HandCoins,
  History,
  House,
  IdCard,
  Inbox,
  Info,
  Key,
  Landmark,
  LogIn,
  Layers,
  LayoutGrid,
  List,
  LoaderCircle,
  Lock,
  LockOpen,
  LogOut,
  Mail,
  MapPin,
  Megaphone,
  MessageSquare,
  MousePointerClick,
  Monitor,
  Package,
  PackageX,
  Pencil,
  Phone,
  PiggyBank,
  Radio,
  Receipt,
  RefreshCw,
  RotateCcw,
  Save,
  Search,
  SearchX,
  ShieldCheck,
  ShieldX,
  Settings,
  Shield,
  Signal,
  Skull,
  Store,
  Smartphone,
  SquarePen,
  Tags,
  ToggleLeft,
  Trash2,
  TriangleAlert,
  TrendingUp,
  Truck,
  User,
  UserX,
  Users,
  Wrench,
  X,
  Zap,
};

/**
 * Mapping from old BWG icon names to Lucide icon names.
 * Used during migration and for sidebar navigation.
 */
export const ICON_NAME_MAP: Record<string, string> = {
  'address-card': 'contact',
  back: 'arrow-left',
  bell: 'bell',
  box: 'package',
  calendar: 'calendar',
  'card-edit': 'square-pen',
  'categories-banking': 'chart-bar',
  'chevron-down': 'chevron-down',
  clock: 'clock',
  close: 'x',
  comments: 'message-square',
  copy: 'copy',
  'credit-card': 'credit-card',
  download: 'download',
  edit: 'pencil',
  error: 'circle-alert',
  'error-cross': 'circle-x',
  'external-link': 'external-link',
  eye: 'eye',
  file: 'file-text',
  filter: 'filter',
  flag: 'flag',
  grid: 'layout-grid',
  history: 'history',
  home: 'house',
  'id-card': 'id-card',
  info: 'info',
  list: 'list',
  lock: 'lock',
  'lock-open': 'lock-open',
  megaphone: 'megaphone',
  more: 'ellipsis',
  'order-error': 'package-x',
  positions: 'trending-up',
  profile: 'user',
  question: 'circle-help',
  reset: 'rotate-ccw',
  'sad-face': 'frown',
  search: 'search',
  settings: 'settings',
  shield: 'shield',
  skull: 'skull',
  sort: 'arrow-up-down',
  'sort-down': 'arrow-down',
  'sort-up': 'arrow-up',
  spinner: 'loader-circle',
  success: 'circle-check',
  tags: 'tags',
  toggle: 'toggle-left',
  tools: 'wrench',
  users: 'users',
  warning: 'triangle-alert',
};
